export default __webpack_public_path__ + "static/media/screen5.182fa7b5.png";